import type { Module } from 'vuex';
import { Language } from '@/types/Language';
import {RootState} from "@/store";

export interface LanguagesState {
  languages: Language[];
}

const languagesModule: Module<LanguagesState, RootState> = {
  namespaced: true,

  state: (): LanguagesState => ({
    languages: [],
  }),

  getters: {
    getById: (state) => (idLanguage: number): Language | undefined => {
      return state.languages.find(language => language.idLanguage === idLanguage);
    },
  },

  mutations: {
    setLanguages(
      state,
      payload: { languages: Record<number, any> }
    ) {
      state.languages = Object
        .values(payload.languages)
        .map(raw => Language.fromRaw(raw));
    },

    setLanguageCreate(
      state,
      payload: {
        idLanguage: number;
        code: string;
        selfTitle: string;
        rtl: boolean;
        locked?: boolean;
      }
    ) {
      const raw = {
        idLanguage: payload.idLanguage,
        code: payload.code,
        selfTitle: payload.selfTitle,
        rtl: payload.rtl,
        locked: payload.locked ?? false,
      };
      state.languages.push(Language.fromRaw(raw));
    },

    setLanguageUpdate(
      state,
      payload: {
        idLanguage: number;
        code?: string;
        selfTitle?: string;
        rtl?: boolean;
      }
    ) {
      const language = state.languages.find(language => language.idLanguage === payload.idLanguage);
      if (!language) return;
      if (payload.code !== undefined) language.code = payload.code;
      if (payload.selfTitle !== undefined) language.selfTitle = payload.selfTitle;
      if (payload.rtl !== undefined) language.rtl = payload.rtl;
    },

    setLanguageDelete(
      state,
      payload: { idLanguage: number }
    ) {
      state.languages = state.languages.filter(
        language => language.idLanguage !== payload.idLanguage
      );
    },

    setLanguageLock(
      state,
      payload: { idLanguage: number }
    ) {
      const language = state.languages.find(language => language.idLanguage === payload.idLanguage);
      if (language) language.locked = true;
    },

    setLanguageUnlock(
      state,
      payload: { idLanguage: number }
    ) {
      const language = state.languages.find(language => language.idLanguage === payload.idLanguage);
      if (language) language.locked = false;
    },
  },

  actions: {
    wsSetLanguages({ commit }, payload) {
      commit('setLanguages', payload);
    },
    wsLanguageCreate({ commit }, payload) {
      commit('setLanguageCreate', payload);
    },
    wsLanguageUpdate({ commit }, payload) {
      commit('setLanguageUpdate', payload);
    },
    wsLanguageDelete({ commit }, payload) {
      commit('setLanguageDelete', payload);
    },
    wsLanguageLock({ commit }, payload) {
      commit('setLanguageLock', payload);
    },
    wsLanguageUnlock({ commit }, payload) {
      commit('setLanguageUnlock', payload);
    },
  },
};

export default languagesModule; 